<template>
    <div class="property-input property-item form-group row align-items-center">
        <label for="ORDER_PROP_5" class="col-lg-3 col-form-label"><span>Город / Населенный пункт</span><span
                class="color-dark-red">*</span></label>
        <div class="col-lg-9">

            <el-autocomplete
                    id="ORDER_PROP_5"
                    class="form-control"
                    v-model="value.value"
                    :fetch-suggestions="querySearch"
                    placeholder="Введите адрес"
                    @select="handleSelect"

                    :trigger-on-focus="false"
            />
        </div>
    </div>
</template>

<script>
  export default {
    data () {
      return {
        links: []
      }
    },
    props: {
      value: {
        default: []
      },
      disabled: {
        type: Boolean,
        default: false
      }
    },
    methods: {
      querySearch (queryString, cb) {
        let params = new FormData()
        params.append('QUERY', queryString)
        params.append('LIMIT', '50')
        params.append('PAGE', '0')
        this.$http.post('/local/components/sb/sale.location.selector.search/get.php', params).then(response => {
          console.log(response)
         // response = JSON.parse(response);
          let data = response.data.data['ITEMS']
         if(data.length){
          data.map(item => {
            console.log(item,'ITEM');
            item.value = item.DISPLAY
            return item;
          });

          console.log(cb,'cb');
       cb(response.data.data['ITEMS'])
        }
        })
      },
      handleSelect (item) {
        console.log(item,'handleSelect');
        this.$emit('change', item)
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/vue/components/order/components/LocationInput.vue